define('view/disclosure/disclosure.history.tab.page.view',['require','exports','module','blockit','formkit/formkit','backbone.radio','fukit','view/disclosure/action.items.component','handlebars','underscore','view/disclosure/persistent.left.sidebar','view/disclosure/persistent.left.sidebar.modals','view/disclosure/modals/disclosure.comment.modal','fukit','behavior/navigate.on.tab.press.behavior'],function(require, exports, module) {
  // prettier-ignore
  var BlocKit                     = require('blockit'),
      FormKit                     = require('formkit/formkit'),
      Radio                       = require('backbone.radio'),
      ROLES                 = require('fukit').Roles,
      ActionItemsComponent        = require('view/disclosure/action.items.component'),
      Handlebars                  = require('handlebars'),
      _                           = require('underscore'),
  //persistent left sidebar and modals
      PersistentLeftSidebar       = require('view/disclosure/persistent.left.sidebar'),
      PersistentLeftSidebarModals = require('view/disclosure/persistent.left.sidebar.modals'),
      DisclosureCommentModal      = require('view/disclosure/modals/disclosure.comment.modal'),
  //behaviors
      AuthorizationBehavior       = require('fukit').AuthorizationBehavior,
      NavigateOnTabPressBehavior  = require('behavior/navigate.on.tab.press.behavior');

  //page specific modals
  var historyTabModals = { disclosureCommentModal: { type: DisclosureCommentModal } };

  var DisclosureHistoryPageLayout = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      //Parent two column layout
      //combine with sidebar modals
      modals: _.extend(historyTabModals, PersistentLeftSidebarModals),
      root: {
        type: BlocKit.TwoColumnLeftRailLayoutView,
        pageHeader: {
          headerText: 'COI Disclosures',
          breadcrumbs: [
            {
              text: 'COI Disclosures',
              route: 'disclosure:list',
              behaviors: {
                AuthorizationBehavior: {
                  // for COI Admin
                  visibleOnlyWhen: [
                    {
                      roles: [ROLES.COI_EFORM_TEMPLATE_ACCESS]
                    },
                  ],
                  behaviorClass: AuthorizationBehavior
                }
              },
            },

            {
              // Note: text should have a binding to a field disclosureOwnerFullName
              text: 'Disclosure - Owner',
              behaviors: {
                updateCrumbWithPersonNameBehavior: {
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  optionValues: {
                    text: {
                      formatter: function() {
                        var disclosureDetailModel = Radio.request(
                            'AppKit.resourceService',
                            'resource',
                            'disclosure'
                        );
                        var displayName = '';

                        if (disclosureDetailModel) {
                          var fullName = disclosureDetailModel.get('disclosureOwnerFullName');

                          if (fullName && fullName.trim().length > 0) {
                            displayName = displayName + fullName;
                          }
                        }

                        return displayName;
                      },
                    },
                  },
                },
              },
            },
          ],
          //Action buttons are created from workflow options available to the user at any given step in the workflow
          //Since the tabbed views have the same actions component definition, we've moved those into a common module
          actionsFromCollection: ActionItemsComponent,
        },
        contentColumn: {
          components: [
            {
              type: BlocKit.TabsContainerView,
              openTabIndex: 2,
              behaviors: {
                navigateOnTabPress: {
                  routeParams: { primaryId: '@state.primaryId' },
                  behaviorClass: NavigateOnTabPressBehavior,
                },
              },
              components: [
                {
                  tabMenuItem: {
                    text: 'COI Disclosure Answers',
                    horizontalNavMode: true,
                    routeName: 'disclosure:form',
                    attributes: {
                      style: 'cursor: pointer;',
                    },
                  },
                },
                {
                  tabMenuItem: {
                    text: 'Documents',
                    horizontalNavMode: true,
                    routeName: 'disclosure:documents',
                    attributes: {
                      style: 'cursor: pointer;',
                    },
                  },
                },

                {
                  tabMenuItem: {
                    text: 'Process History',
                    horizontalNavMode: true,
                  },
                  tabContent: {
                    type: BlocKit.PageableTableView,
                    collection: '@resources.routingHistoryCollection',
                    columns: [
                      { text: 'Action', data: 'routingOption', sortable: false },
                      {
                        text: 'Name',
                        data: 'fullName',
                        sortable: false,
                        sort: 'Person.firstName,lastName',
                        formatter: function(fullName, routingHistoryModel) {
                          /* Need to check for white space since fullName is a
                          constructed virtual property on PersonModel that
                          adds a space inbetween first and last name*/
                          var fullNameIsWhiteSpace = fullName.indexOf(' ') >= 0;
                          if (fullNameIsWhiteSpace && !routingHistoryModel.get('assignee')) {
                            return 'Reviewer';
                          }
                          if(fullName.length === 0 &&
                              (routingHistoryModel.get('autoApprove') === 'TRUE' || routingHistoryModel.get('autoAssign') === 'TRUE')) {
                            return 'Automated Action';
                          }
                          return fullName;
                        },
                      },
                      {
                        text: 'Completion Date',
                        data: 'completionTime',
                        sortable: false,
                        sort: 'RoutingHistory.completionTime',
                        formatter: BlocKit.Formatter.date({
                          format: 'L LT',
                          emptyValue: '--',
                        }),
                      },
                      {
                        text: 'Notes',
                        data: 'reviewerComment',
                        sortable: false,
                        sort: 'RoutingHistory.reviewerComment',
                        formatter: function() {
                          if (arguments[0]) {
                            var trimmedComment = arguments[0].trim();
                            var quotedComment = '"' + trimmedComment + '"';
                            if (quotedComment.length > 130) {
                              var truncatedComment =
                                quotedComment.slice(0, 129) + '..." <span class="text primary underline">More</span>';
                              return new Handlebars.SafeString(truncatedComment);
                            } else {
                              return new Handlebars.SafeString(quotedComment);
                            }
                          } else return new Handlebars.SafeString('');
                        },
                        behaviors: {
                          PassDataCommentModal: {
                            behaviorClass: Mn.Behavior.extend({
                              onRender: function() {
                                this.listenTo(this.view, 'press', function() {
                                  var reviewerComment = this.view.model.get('reviewerComment');
                                  var disclosureChannel = Radio.channel('disclosureChannel');
                                  disclosureChannel.reply('reviewer:comment', reviewerComment);
                                });
                              },
                              onClose: function() {
                                this.stopListening();
                              },
                            }),
                          },
                          OpenCommentModalOnPress: {
                            modalName: function() {
                              if (
                                this.view.model.get('reviewerComment') &&
                                this.view.model.get('reviewerComment').length >= 128
                              ) {
                                return 'disclosureCommentModal';
                              } else {
                                return null;
                              }
                            },
                            behaviorClass: BlocKit.ShowModalOnEventBehavior,
                          },
                        },
                        attributes: {
                          style: 'cursor: pointer;',
                        },
                      },
                    ],
                    table: {
                      emptyText: 'No routing history.',
                      selectable: false,
                    },
                  },
                },
              ],
            },
          ],
        },
        //Persistent left column process information, workflow tasks, etc.
        railColumn: PersistentLeftSidebar,
      },
    },
  });

  module.exports = DisclosureHistoryPageLayout;
});


